import styled from "styled-components"
import media from "src/styles/media"
import Img from "gatsby-image"
import Link from "src/components/util/TransitionLink"

export const PostWrapper = styled.div`
  padding: 40px 0;
  max-width: 48rem;
  margin: 0 auto;

  ${media.lessThan("md")`
    max-width: 90%;
    padding-bottom: 0;
  `}
`

export const PostLinkBack = styled(Link)`
  display: block;
  font-size: 17px;
  margin-bottom: 30px;
  color: var(--primary);
  font-weight: 600;

  &:hover {
    color: var(--primary);
  }

  ${media.lessThan("lg")`
      margin-bottom: 25px;
  `}
`

export const PostHeader = styled.header`
  color: #0a1431;
  margin: auto;
  padding: 0 0 40px 0;

  ${media.lessThan("lg")`
    padding: 10px 0;
    margin-bottom: 10px;
  `}
`

export const PostTitle = styled.h1`
  font-size: 2.8rem;
  font-weight: 700;
  margin-bottom: 10px;

  ${media.lessThan("lg")`
    font-size: 1.6rem;
    line-height: 1.1;
    margin-bottom: 12px;
  `}
`

export const PostDescription = styled.h2`
  font-size: 1.5rem;
  font-weight: 200;

  ${media.lessThan("lg")`
    font-size: 18px;
    line-height: 1.3;
    margin-bottom: 20px;
  `}
`

export const PostDate = styled.p`
  font-size: 16px;
  letter-spacing: 1.2px;
  font-weight: 500;
  margin-bottom: -5px;

  ${media.lessThan("lg")`
    margin-bottom: 5px;
    font-size: 13px;
  `}
`

export const MainContent = styled.section`
  margin: auto;
  padding: 40px 0;

  ${media.lessThan("lg")`
    padding: 1.3rem 0;
  `}

  ${media.lessThan("md")`
    padding-bottom: 0;
  `}

  p,
  h1,
  h2,
  h3,
  h4,
  ul,
  ol,
  .tags,
  iframe,
  .button-post {
    color: #0a1431;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.9;
    letter-spacing: 0.033rem;

    ${media.lessThan("md")`
      font-size: 16px;
    `}
  }
  h1,
  h2,
  h3,
  h4,
  h5 {
    margin: 2.4rem auto 1rem;
  }
  ul,
  ol {
    list-style: disc;
    padding-left: 2.5rem;
    margin: 0 auto 1.6rem;
  }
  li {
    padding: 0.625rem 0;
    & > ul {
      margin-bottom: 0;
    }
  }
  p,
  li {
    code {
      word-wrap: break-word;
    }
  }
  img {
    display: block;
    max-width: 100%;
    margin: 1.875rem auto;
  }
  iframe {
    padding: 0 1.6rem 1.6rem;
    width: 100%;
  }
  blockquote {
    color: #fff;
    border-left: 0.3rem solid var(--primary);
    padding: 0 1.475rem;
    font-style: italic;
    margin: 3.125rem auto;
  }
  hr {
    border: 1px solid #0a1431;
    margin: 3rem auto;
  }
  #twitter-widget-0,
  .instagram-media,
  .twitter-tweet {
    margin: 20px auto !important;
  }
  h1,
  h2,
  h3,
  h4,
  h5 {
    font-weight: 800;
    letter-spacing: 0.069rem;
    line-height: 1.4;
  }
  h1 {
    font-size: 2.8rem;

    ${media.lessThan("lg")`
      padding: 0 1rem;
    `}
  }
  h2 {
    font-size: 2.1rem;

    ${media.lessThan("lg")`
      font-size: 1.375rem;
    `}
  }
  h3 {
    font-size: 1.6rem;

    ${media.lessThan("lg")`
      font-size: 1.125rem;
    `}
  }
  h4 {
    font-size: 1.4rem;
  }
  h5 {
    font-size: 1.2rem;
  }
  strong {
    font-weight: 700;
  }
  .gatsby-resp-image-background-image {
    z-index: 2;
    opacity: 1 !important;
  }
  .gatsby-resp-image-image {
    box-shadow: none !important;
    transition: opacity 0.2s;
    &.lazyload {
      opacity: 0;
    }
    &.lazyloaded {
      opacity: 1;
      z-index: 3;
    }
  }
  .gatsby-highlight {
  }
  .instagram-media {
    margin: 1rem auto !important;
  }
  a {
    border-bottom: 1px dashed var(--primary);
    color: var(--primary);
    text-decoration: none;
    transition: opacity 0.5s;
    svg {
      color: #fff;
    }
    &:hover {
      opacity: 0.8;
    }
  }
  img ~ em {
    display: block;
    text-align: center;
    font-size: 14px;
    line-height: 1.3;
  }
`

export const PostDivisor = styled(Img)`
  width: 47px;
  margin: 0 auto;
  margin-bottom: 25px;

  ${media.lessThan("md")`
        width: 40px;
    `}
`

export const PostSignature = styled.section`
  display: flex;
  border: 1px solid #d4d4d4;
  padding: 24px 0 10px 0;
  border-width: 1px 0 1px 0;
`

export const PostSignatureCaption = styled.div`
  display: flex;
  flex-direction: column;
  color: var(--dark);
`

export const PostSignatureImg = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 20px;

  ${media.lessThan("md")`
    width: 70px;
    height: 70px;
  `}
`

export const PostSignatureTitle = styled.h1`
  font-weight: 300;
  font-size: 14px;
  letter-spacing: 1px;
  color: #474747;
  font-weight: normal;

  ${media.lessThan("md")`
    font-size: 13px;
  `}

  span {
    font-size: 28px;
    font-weight: 600;
    letter-spacing: 0.8px;
    display: block;
    color: var(--dark);
    margin-top: -5px;

    ${media.lessThan("md")`
        font-size: 26px;
        margin-bottom: -6px;
      `}
  }
`

export const PostSignatureDesc = styled.p`
  max-width: 400px;

  ${media.lessThan("md")`
   font-size: 14px;
  `}
`
